namespace $.$$ {

	$mol_style_define( $shm_service_dashboard_head, {
		width: '100%',
		minWidth: 0,
		overflow: 'hidden',
		align: { items: 'center' },
		flex: { grow: 1, shrink: 1 },

		Title_edit: {
			minWidth: 0,
			width: '12rem',
			maxWidth: '12rem',
			['fieldSizing' as any]: 'content',
			flex: { grow: 0, shrink: 1 },
		},

		Task_mode_controls: {
			align: { items: 'center' },
			flex: { grow: 0, shrink: 0 },
		},
	} )

}
